/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import { useAuth } from '../../../../app/modules/auth'

export function AsideMenuMain() {
  const intl = useIntl()


  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      {/* <AsideMenuItem
        to='/PotreeViewer'
        icon='/media/icons/duotune/art/art002.svg'
        title='Dashboard'
        fontIcon='bi-app-indicator'
      />           */}
      <AsideMenuItem
        to='/overview'
        icon='/media/icons/duotune/general/gen018.svg'
        title='Overview'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/waterstanden'
        icon='/media/icons/duotune/general/gen016.svg'
        title='Waterstanden'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/fileupload'
        icon='/media/icons/duotune/general/gen019.svg'
        title='File Upload'
        fontIcon='bi-layers'
      />
      
  
    </>
  )
  

    
}
